module.exports = __webpack_public_path__ + "static/media/item-3.f6fffc79.jpeg";